import React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { Checkbox } from "./ui/checkbox";
import { Input } from "./ui/input";
import { RotateCcw } from "lucide-react";

const Group = ({ title, options, selected, onToggle }) => (
  <div>
    <p className="font-display text-brand-navy text-sm mb-2.5">{title}</p>
    <div className="space-y-2">
      {options.map((opt) => {
        const checked = selected.includes(opt);
        return (
          <label key={opt} className="flex items-center gap-2.5 cursor-pointer group">
            <Checkbox checked={checked} onCheckedChange={() => onToggle(opt)} className="data-[state=checked]:bg-brand-blue data-[state=checked]:border-brand-blue" />
            <span className={`text-sm transition-colors ${checked ? "text-brand-navy font-semibold" : "text-slate-500 group-hover:text-brand-navy"}`}>{opt}</span>
          </label>
        );
      })}
    </div>
  </div>
);

const FilterPanel = ({ filters, setFilters, options, onReset, vertical = false }) => {
  const toggle = (key, value) => {
    setFilters((f) => {
      const arr = f[key];
      return { ...f, [key]: arr.includes(value) ? arr.filter((x) => x !== value) : [...arr, value] };
    });
  };
  const setPrice = (val) => setFilters((f) => ({ ...f, price: val }));
  const clampPrice = (idx, raw) => {
    let v = parseInt(raw || "0", 10);
    if (isNaN(v)) v = idx === 0 ? options.priceMin : options.priceMax;
    v = Math.max(options.priceMin, Math.min(options.priceMax, v));
    const next = [...filters.price];
    next[idx] = v;
    if (next[0] > next[1]) { if (idx === 0) next[1] = v; else next[0] = v; }
    setPrice(next);
  };

  return (
    <div>
      <div className="flex items-center justify-between pb-4 border-b border-slate-100">
        <h3 className="font-display text-lg text-brand-navy">Filters</h3>
        <button onClick={onReset} className="inline-flex items-center gap-1 text-xs font-semibold text-brand-pink hover:text-brand-pinkdark transition-colors">
          <RotateCcw className="w-3.5 h-3.5" /> Alles wissen
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-6 mt-5">
        <Group title="Soort springkussen" options={options.soorten} selected={filters.soorten} onToggle={(v) => toggle("soorten", v)} />
        {options.andere && options.andere.length > 0 && (
          <Group title="Andere producten" options={options.andere} selected={filters.andere} onToggle={(v) => toggle("andere", v)} />
        )}
        <Group title="Leeftijd" options={options.leeftijden} selected={filters.leeftijden} onToggle={(v) => toggle("leeftijden", v)} />
        <Group title="Formaat" options={options.formaten} selected={filters.formaten} onToggle={(v) => toggle("formaten", v)} />
        <Group title="Aantal personen" options={options.personen} selected={filters.personen} onToggle={(v) => toggle("personen", v)} />
        <Group title="Thema's" options={options.themas} selected={filters.themas} onToggle={(v) => toggle("themas", v)} />
        <Group title="Locatie" options={options.locaties} selected={filters.locaties} onToggle={(v) => toggle("locaties", v)} />
        <Group title="Soort evenement" options={options.evenementen} selected={filters.evenementen} onToggle={(v) => toggle("evenementen", v)} />

        {/* Price */}
        <div className="col-span-2 sm:col-span-3 lg:col-span-1">
          <p className="font-display text-brand-navy text-sm mb-3">Prijs per dag</p>
          <SliderPrimitive.Root
            min={options.priceMin} max={options.priceMax} step={5}
            value={filters.price} onValueChange={setPrice} minStepsBetweenThumbs={1}
            className="relative flex items-center w-full h-5 touch-none select-none"
          >
            <SliderPrimitive.Track className="relative h-1.5 w-full grow rounded-full bg-brand-bluelight">
              <SliderPrimitive.Range className="absolute h-full rounded-full bg-brand-blue" />
            </SliderPrimitive.Track>
            <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full bg-white border-2 border-brand-blue shadow cursor-grab active:cursor-grabbing focus:outline-none" />
            <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full bg-white border-2 border-brand-blue shadow cursor-grab active:cursor-grabbing focus:outline-none" />
          </SliderPrimitive.Root>
          <div className="flex items-center gap-3 mt-3">
            <div className="flex-1">
              <label className="text-xs text-slate-400 font-semibold">Min €</label>
              <Input type="number" value={filters.price[0]} onChange={(e) => clampPrice(0, e.target.value)} className="mt-1 h-9" />
            </div>
            <div className="flex-1">
              <label className="text-xs text-slate-400 font-semibold">Max €</label>
              <Input type="number" value={filters.price[1]} onChange={(e) => clampPrice(1, e.target.value)} className="mt-1 h-9" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
